import { render, staticRenderFns } from "./MyApplyRecord.vue?vue&type=template&id=5c03fd21&scoped=true"
import script from "./MyApplyRecord.vue?vue&type=script&lang=js"
export * from "./MyApplyRecord.vue?vue&type=script&lang=js"
import style0 from "./MyApplyRecord.vue?vue&type=style&index=0&id=5c03fd21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03fd21",
  null
  
)

export default component.exports